var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'a' : 'button',_vm._b({tag:"component",class:[
		`button button--${_vm.bgColor}`,
		{
			'button--small': _vm.isSmall,
			'no-icon': !_vm.iconSwitch
		}
	],attrs:{"href":_vm.link,"target":_vm.linkCondition === true ? '_blank' : null,"rel":_vm.link ? 'noopener noreferrer' : null,"title":_vm.elementTitle,"role":_vm.elementRole,"aria-label":_vm.elementAriaLabel,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('button-click', $event)}}},'component',_vm.$attrs,false),[_vm._v("\n\t"+_vm._s(_vm.text)+"\n\t"),(_vm.iconSwitch)?_c('span',{class:_vm.iconClass,attrs:{"role":_vm.iconRole ? _vm.iconRole : null,"aria-label":_vm.iconAriaLabel,"aria-hidden":!_vm.iconAriaLabel ? 'true' : null}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }